import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import {DocumentService} from "../../../core/services/document.service";
import {ToastrService} from "ngx-toastr";

@Component({
  selector: 'app-waring-signature',
  templateUrl: './confirm-forward.component.html',
  styleUrls: ['./confirm-forward.component.scss']
})
export class ConfirmForwardComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ConfirmForwardComponent>,
    private toast: ToastrService,
    private documentService: DocumentService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // them chuc nang close message băng Esc vaf click chuot
    dialogRef.disableClose = false;
  }

  ngOnInit() {
  }

  onBackClick(){
    this.dialogRef.close();
  }

  onNextClick(){
    const body = {
      contractId: this.data.contractId,
      receiveId: this.data.receiveId,
      receiveType: this.data.receiveType,
    }
    this.documentService.forwardContract(body).subscribe(res => {
      if (res.message === 'OK' && res.success) {
        this.dialogRef.close('success');
      } else {
        this.toast.error(res.message);
        this.dialogRef.close(res.data.errorReason);
      }
    })
  }
}
